"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselSlideWidthOptions: ()=>CarouselSlideWidthOptions,
    CarouselImageSlideWidthOptions: ()=>CarouselImageSlideWidthOptions,
    CarouselBleedSpacingOptions: ()=>CarouselBleedSpacingOptions,
    CarouselFullBleedPaddingOptions: ()=>CarouselFullBleedPaddingOptions,
    CarouselPaginationOptions: ()=>CarouselPaginationOptions,
    carouselVariants: ()=>carouselVariants,
    CarouselNumSlidesOptions: ()=>CarouselNumSlidesOptions,
    CarouselAutoplayOptions: ()=>CarouselAutoplayOptions,
    CarouselHideArrowsOnMobileOrTouchOptions: ()=>CarouselHideArrowsOnMobileOrTouchOptions,
    CarouselTypeOptions: ()=>CarouselTypeOptions,
    CarouselContentSlideWidthOptions: ()=>CarouselContentSlideWidthOptions,
    CarouselRoundedOptions: ()=>CarouselRoundedOptions,
    CarouselBleedOptions: ()=>CarouselBleedOptions
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const MASK_GRADIENT = 'md:mask-[linear-gradient(90deg,transparent,#000_16px,#000_calc(100%-16px),transparent_100%)]';
const carouselVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        wrapperParentSlot: 'h-full',
        wrapperSlot: 'h-full',
        rootSlot: 'relative m-auto h-full',
        viewportSlot: 'overflow-hidden',
        containerSlot: 'pan-y pinch-zoom relative flex',
        slideSlot: '',
        prevButtonSlot: 'absolute top-[calc(50%-20px)]',
        nextButtonSlot: 'absolute top-[calc(50%-20px)]',
        hiddenButtonSlot: 'absolute top-[calc(50%-20px)]',
        dotsPaginationSlot: 'absolute bottom-2 left-0 right-0 flex items-center justify-center',
        dotButtonSlot: 'inline-flex h-7 w-7 cursor-pointer items-center justify-center',
        dotSlot: 'border-neutral-1 bg-neutral-12/10 h-2 w-2 rounded-full border',
        dotSelectedSlot: 'bg-neutral-1 h-3 w-3'
    },
    variants: {
        type: {
            image: {},
            content: {}
        },
        numSlides: {
            'one-two-three': {},
            'one-two-two': {},
            'one-one-one': {},
            'two-four-six': {},
            'three-six-nine': {}
        },
        slideGap: {
            3: {}
        },
        rounded: {
            'top-left': {
                viewportSlot: 'rounded-tl-lg'
            },
            top: {
                viewportSlot: 'rounded-t-lg'
            },
            left: {
                viewportSlot: 'rounded-l-lg'
            },
            all: {
                viewportSlot: 'rounded-lg'
            },
            none: {}
        },
        slideWidth: {
            min: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                slideSlot: 'min-w-64'
            },
            auto: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                slideSlot: 'min-w-0 flex-shrink-0 flex-grow-0'
            },
            same: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                rootSlot: '@container relative mx-auto',
                slideSlot: 'flex-shrink-0 flex-grow-0'
            },
            image: {
                slideSlot: 'min-w-0 flex-shrink-0 flex-grow-0 basis-full'
            }
        },
        isDotSelected: {
            true: {
                dotSlot: 'bg-neutral-1 h-3 w-3'
            },
            false: {
                dotSlot: 'bg-neutral-12/10 border-neutral-1 h-2 w-2'
            }
        },
        loop: {
            true: {},
            false: {}
        },
        hideArrowsOnMobileOrTouch: {
            responsive: {},
            always: {},
            never: {}
        },
        bleed: {
            defaultBleed: {},
            fullBleed: {},
            customBleed: {},
            responsiveBleed: {}
        },
        bleedSpacing: {
            2: {},
            3: {},
            4: {},
            6: {},
            8: {}
        },
        fullBleedPadding: {
            2: {},
            3: {},
            4: {},
            6: {},
            8: {}
        }
    },
    compoundVariants: [
        {
            hideArrowsOnMobileOrTouch: 'responsive',
            class: {
                prevButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)] hidden sm:block',
                nextButtonSlot: 'absolute right-[8px] top-[calc(50%-12px)] hidden sm:block',
                hiddenButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)] hidden sm:block'
            }
        },
        {
            hideArrowsOnMobileOrTouch: 'always',
            class: {
                prevButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)] hidden',
                nextButtonSlot: 'absolute right-[8px] top-[calc(50%-12px)] hidden',
                hiddenButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)] hidden'
            }
        },
        {
            hideArrowsOnMobileOrTouch: 'never',
            class: {
                prevButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)]',
                nextButtonSlot: 'absolute right-[8px] top-[calc(50%-12px)]',
                hiddenButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)]'
            }
        },
        {
            slideWidth: 'image',
            class: {
                prevButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)]',
                nextButtonSlot: 'absolute right-[8px] top-[calc(50%-12px)]',
                hiddenButtonSlot: 'absolute left-[8px] top-[calc(50%-12px)]'
            }
        },
        {
            slideWidth: 'min',
            class: {
                prevButtonSlot: 'absolute left-[-12px] top-[calc(50%-20px)]',
                nextButtonSlot: 'absolute right-[-12px] top-[calc(50%-20px)]',
                hiddenButtonSlot: 'absolute left-[-12px] top-[calc(50%-20px)]'
            }
        },
        {
            slideWidth: 'auto',
            class: {
                prevButtonSlot: 'absolute left-[-12px] top-[calc(50%-20px)]',
                nextButtonSlot: 'absolute right-[-12px] top-[calc(50%-20px)]',
                hiddenButtonSlot: 'absolute left-[-12px] top-[calc(50%-20px)]'
            }
        },
        {
            slideWidth: 'same',
            class: {
                prevButtonSlot: 'absolute left-[-12px] top-[calc(50%-20px)]',
                nextButtonSlot: 'absolute right-[-12px] top-[calc(50%-20px)]',
                hiddenButtonSlot: 'absolute left-[-12px] top-[calc(50%-20px)]'
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'min',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-4 -my-8 px-4 py-8`
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'auto',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-4 -my-8 px-4 py-8`
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'same',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-4 -my-8 px-4 py-8`
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'min',
            fullBleedPadding: '2',
            class: {
                wrapperParentSlot: 'w-full',
                wrapperSlot: 'ml-[calc(50%-50vw)] w-screen',
                rootSlot: 'flex max-w-[calc(100%-var(--spacing)*2)] items-center',
                viewportSlot: 'm-auto -my-8 overflow-visible py-8'
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'auto',
            fullBleedPadding: '2',
            class: {
                wrapperParentSlot: 'w-full',
                wrapperSlot: 'ml-[calc(50%-50vw)] w-screen',
                rootSlot: 'flex max-w-[calc(100%-var(--spacing)*2)] items-center',
                viewportSlot: 'm-auto -my-8 overflow-visible py-8'
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'same',
            fullBleedPadding: '2',
            class: {
                wrapperParentSlot: 'w-full',
                wrapperSlot: 'ml-[calc(50%-50vw)] w-screen',
                rootSlot: 'flex max-w-[calc(100%-var(--spacing)*2)] items-center',
                viewportSlot: 'm-auto -my-8 overflow-visible py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '2',
            class: {
                viewportSlot: '-mx-2 -my-8 px-2 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '2',
            class: {
                viewportSlot: '-mx-2 -my-8 px-2 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '2',
            class: {
                viewportSlot: '-mx-2 -my-8 px-2 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '3',
            class: {
                viewportSlot: '-mx-3 -my-8 px-3 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '3',
            class: {
                viewportSlot: '-mx-3 -my-8 px-3 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '3',
            class: {
                viewportSlot: '-mx-3 -my-8 px-3 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '4',
            class: {
                viewportSlot: '-mx-4 -my-8 px-4 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '4',
            class: {
                viewportSlot: '-mx-4 -my-8 px-4 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '4',
            class: {
                viewportSlot: '-mx-4 -my-8 px-4 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '6',
            class: {
                viewportSlot: '-mx-6 -my-8 px-6 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '6',
            class: {
                viewportSlot: '-mx-6 -my-8 px-6 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '6',
            class: {
                viewportSlot: '-mx-6 -my-8 px-6 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '8',
            class: {
                viewportSlot: '-mx-8 -my-8 px-8 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '8',
            class: {
                viewportSlot: '-mx-8 -my-8 px-8 py-8'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '8',
            class: {
                viewportSlot: '-mx-8 -my-8 px-8 py-8'
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'min',
            bleedSpacing: '2',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-2 -my-8 px-2 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'auto',
            bleedSpacing: '2',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-2 -my-8 px-2 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'same',
            bleedSpacing: '2',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-2 -my-8 px-2 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'min',
            bleedSpacing: '3',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-3 -my-8 px-3 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'auto',
            bleedSpacing: '3',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-3 -my-8 px-3 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'same',
            bleedSpacing: '3',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-3 -my-8 px-3 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'min',
            bleedSpacing: '4',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-4 -my-8 px-4 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'auto',
            bleedSpacing: '4',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-4 -my-8 px-4 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'same',
            bleedSpacing: '4',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${MASK_GRADIENT} -mx-4 -my-8 px-4 py-8 md:-mx-4 md:-my-8 md:px-4 md:py-8`
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one-two-three',
            slideGap: '3',
            class: {
                rootSlot: "[--slide-gap:12px] [--peek-amount:56px] [--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))] [--slide-width-2:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))] [--slide-width-3:calc(((100%-var(--peek-amount))/3)-var(--slide-gap))]",
                slideSlot: '@3xl:w-[var(--slide-width-2)] @7xl:w-[var(--slide-width-3)] w-[var(--slide-width-1)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one-two-two',
            slideGap: '3',
            class: {
                rootSlot: "[--slide-gap:12px] [--peek-amount:56px] [--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))] [--slide-width-2:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))] [--slide-width-3:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))]",
                slideSlot: '@3xl:w-[var(--slide-width-2)] @7xl:w-[var(--slide-width-3)] w-[var(--slide-width-1)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one-one-one',
            slideGap: '3',
            class: {
                rootSlot: "[--slide-gap:12px] [--peek-amount:56px] [--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))] [--slide-width-2:calc(((100%-var(--peek-amount)))-var(--slide-gap))] [--slide-width-3:calc(((100%-var(--peek-amount)))-var(--slide-gap))]",
                slideSlot: '@3xl:w-[var(--slide-width-2)] @7xl:w-[var(--slide-width-3)] w-[var(--slide-width-1)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'two-four-six',
            slideGap: '3',
            class: {
                rootSlot: "[--slide-gap:12px] [--peek-amount:56px] [--slide-width-1:calc((100%-var(--peek-amount))/2-var(--slide-gap))] [--slide-width-2:calc(((100%-var(--peek-amount))/4)-var(--slide-gap))] [--slide-width-3:calc(((100%-var(--peek-amount))/6)-var(--slide-gap))]",
                slideSlot: '@3xl:w-[var(--slide-width-2)] @7xl:w-[var(--slide-width-3)] w-[var(--slide-width-1)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'three-six-nine',
            slideGap: '3',
            class: {
                rootSlot: "[--slide-gap:12px] [--peek-amount:56px] [--slide-width-1:calc((100%-var(--peek-amount))/3-var(--slide-gap))] [--slide-width-2:calc(((100%-var(--peek-amount))/6)-var(--slide-gap))] [--slide-width-3:calc(((100%-var(--peek-amount))/9)-var(--slide-gap))]",
                slideSlot: '@3xl:w-[var(--slide-width-2)] @7xl:w-[var(--slide-width-3)] w-[var(--slide-width-1)]'
            }
        }
    ],
    defaultVariants: {
        type: 'content',
        numSlides: 'one-two-three',
        rounded: 'all',
        slideGap: '3',
        slideWidth: 'auto',
        hideArrowsOnMobileOrTouch: 'responsive',
        bleed: 'defaultBleed',
        bleedSpacing: '4'
    }
});
const CarouselTypeOptions = [
    'image',
    'content'
];
const CarouselAutoplayOptions = [
    'hover',
    'inview',
    'init'
];
const CarouselPaginationOptions = [
    'numbers',
    'dots'
];
const CarouselRoundedOptions = Object.keys(carouselVariants.variants.rounded);
const CarouselSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth);
const CarouselImageSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth).filter((key)=>'image' === key);
const CarouselContentSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth).filter((key)=>'image' !== key);
const CarouselNumSlidesOptions = Object.keys(carouselVariants.variants.numSlides);
const CarouselHideArrowsOnMobileOrTouchOptions = Object.keys(carouselVariants.variants.hideArrowsOnMobileOrTouch);
const CarouselBleedOptions = Object.keys(carouselVariants.variants.bleed);
const CarouselBleedSpacingOptions = Object.keys(carouselVariants.variants.bleedSpacing);
const CarouselFullBleedPaddingOptions = Object.keys(carouselVariants.variants.fullBleedPadding);
exports.CarouselAutoplayOptions = __webpack_exports__.CarouselAutoplayOptions;
exports.CarouselBleedOptions = __webpack_exports__.CarouselBleedOptions;
exports.CarouselBleedSpacingOptions = __webpack_exports__.CarouselBleedSpacingOptions;
exports.CarouselContentSlideWidthOptions = __webpack_exports__.CarouselContentSlideWidthOptions;
exports.CarouselFullBleedPaddingOptions = __webpack_exports__.CarouselFullBleedPaddingOptions;
exports.CarouselHideArrowsOnMobileOrTouchOptions = __webpack_exports__.CarouselHideArrowsOnMobileOrTouchOptions;
exports.CarouselImageSlideWidthOptions = __webpack_exports__.CarouselImageSlideWidthOptions;
exports.CarouselNumSlidesOptions = __webpack_exports__.CarouselNumSlidesOptions;
exports.CarouselPaginationOptions = __webpack_exports__.CarouselPaginationOptions;
exports.CarouselRoundedOptions = __webpack_exports__.CarouselRoundedOptions;
exports.CarouselSlideWidthOptions = __webpack_exports__.CarouselSlideWidthOptions;
exports.CarouselTypeOptions = __webpack_exports__.CarouselTypeOptions;
exports.carouselVariants = __webpack_exports__.carouselVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselAutoplayOptions",
    "CarouselBleedOptions",
    "CarouselBleedSpacingOptions",
    "CarouselContentSlideWidthOptions",
    "CarouselFullBleedPaddingOptions",
    "CarouselHideArrowsOnMobileOrTouchOptions",
    "CarouselImageSlideWidthOptions",
    "CarouselNumSlidesOptions",
    "CarouselPaginationOptions",
    "CarouselRoundedOptions",
    "CarouselSlideWidthOptions",
    "CarouselTypeOptions",
    "carouselVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
